export const authConsts = {
    LOG_IN: "LOG_IN",
    LOG_OUT: "LOG_OUT",
    GET_STATIC_PAGES: 'GET_STATIC_PAGES'
};
